import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm, Table, Tag, Modal, Form, Switch, Spin
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;
const {RangePicker} = DatePicker;

const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '提货编号',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: '提货单位',
        dataIndex: 'buyer',
        key: 'buyer',
    },
    {
        title: '货品类型',
        dataIndex: 'stock',
        key: 'stock',
    },
    {
        title: '皮重（吨）',
        dataIndex: 'weight1',
        key: 'weight1',
        render: (weight1) => <p>{weight1 ? (weight1/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '毛重（吨）',
        dataIndex: 'weight2',
        key: 'weight2',
        render: (weight2) => <p>{weight2 ? (weight2/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '净重（吨）',
        dataIndex: 'value',
        key: 'value',
        render: (value) => <p>{value ? (value/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '提货车辆',
        dataIndex: 'car',
        key: 'car',
    },
    {
        title: '进厂时间',
        dataIndex: 'intime',
        key: 'intime',
        render: (intime) => <p>{intime ? intime.substring(0,19) : '暂无'}</p>,
    },
    {
        title: '出厂时间',
        dataIndex: 'outtime',
        key: 'outtime',
        render: (outtime) => <p>{outtime ? outtime.substring(0,19) : '暂无'}</p>,
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Print id={record.time}></Print>
                <Button onClick={()=>onGo2(record.id)}>
                    修改
                </Button>
            </Space>
        ),
    },
];

const Load = (that,start,end) => {
    that.setState({
        isLoaded: true,
    });
    fetch("https://pd.pokemonbye.com:8081/api/getweightbetdate?start=" + start + "&end=" + end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1
                }
                console.log(array)
                that.setState({
                    isLoaded: false,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: false,
                    error
                });
            }
        )
}

const Print = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellpickstate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Space>
                <Button onClick={()=>onGo(id)}>
                    打印
                </Button>
            </Space>
        </Popconfirm>
    );
};
const onGo = (id) => {
    window.open("/pagepurticket?type=1&id="+id.id)
};
const onGo2 = (id) => {
    window.location.href="/pagepurpicked?id="+id;
};


class PagePurPickEds extends Component{


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        this.state = {
            title: "提货单",
            county: [],
            area: pid,
            list: [],
            menu: [],
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD') + ' 23:59:59',
        };
    }

    componentDidMount() {

        Load(this,this.state.start,this.state.end)
    }

    render() {

        const onChange = (date, dateString) => {
            console.log(date, dateString);
            let date1 = dateString
            let date2 = dateString + ' 23:59:59'
            this.setState({
                start: date1,
                end: date2
            });
            Load(this,date1,date2)
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                                subTitle="已提货单信息"
                            >
                                <Spin spinning={this.state.isLoaded}>
                                <DatePicker defaultValue={moment()} onChange={onChange}/>
                                <br/>
                                <br/>
                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>
                                </Spin>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PagePurPickEds;


